import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";

const languageSchema = (t: TFunction) =>
  yup.object().shape({
    language: yup.string().required("Language is required"),
    title: yup
      .string()
      .required("Title is required")
      .max(200, t("validations.max_length", { count: 200 })),
    description: yup.string().default(""),
  });

const goalTemplateValidationSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup
      .string()
      .required("This field is required")
      .min(2, t("validations.min_length", { count: 2 }))
      .max(120, t("validations.max_length", { count: 120 })),
    status: yup
      .string()
      .required("This field is required")
      .oneOf(["ACTIVE", "INACTIVE"], "Invalid status"),
    rewardConfigurationId: yup.string().required("This field is required"),
    icon: yup.string().default(""),

    languages: yup.array().of(languageSchema(t)).default([]),

    steps: yup
      .array()
      .of(
        yup.object().shape({
          name: yup
            .string()
            .required("Step name is required")
            .max(200, t("validations.max_length", { count: 200 })),
          status: yup.string().required("Step status is required"),
          order: yup
            .number()
            .typeError("Order must be a number")
            .transform((value, original) =>
              original === "" || original === null || original === undefined
                ? undefined
                : value
            )
            .min(0, "Order must be 0 or greater")
            .nullable()
            .optional(),
          rewardConfigurationId: yup.string().default(""),
          languages: yup.array().of(languageSchema(t)).default([]),
        })
      )
      .default([]),
  });

export type GoalTemplateFormData = InferType<
  ReturnType<typeof goalTemplateValidationSchema>
>;

export default goalTemplateValidationSchema;
